import { useEffect, useRef, useState } from "react";
import ModalBase from "../modals/ModalBase";
import { saveHubEvent } from "../../js/theHub";

export default function HubListingEditModal({ item, session, isOpen, onClose, onSaved }) {
  const [url, setUrl] = useState("");
  const [phone, setPhone] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [error, setError] = useState("");
  const wasOpen = useRef(false);

  useEffect(() => {
    const justOpened = isOpen && !wasOpen.current;
    wasOpen.current = isOpen;
    if (!justOpened || !item) return;
    setUrl(item.url || "");
    setPhone(item.phone || "");
    setContact(item.contact || "");
    setAddress(item.address || "");
    setError("");
  }, [isOpen, item]);

  function submit(event) {
    event.preventDefault();
    if (!item) return;
    setError("");
    try {
      saveHubEvent(
        {
          ...item,
          url: url.trim(),
          phone: phone.trim(),
          contact: contact.trim(),
          address: address.trim(),
        },
        session
      );
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "That listing could not be updated.");
    }
  }

  return (
    <ModalBase isOpen={isOpen} title="Edit listing contact" onClose={onClose}>
      {item ? (
        <form className="the-hub-form" onSubmit={submit}>
          <p className="muted">
            <strong>{item.title}</strong>
          </p>
          <label className="field">
            <span className="field-label">Street address</span>
            <input
              className="field-input"
              value={address}
              onChange={(event) => setAddress(event.target.value)}
              placeholder="Street, city, state"
            />
          </label>
          <label className="field">
            <span className="field-label">Phone</span>
            <input
              className="field-input"
              type="tel"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
              placeholder="619-544-1300"
            />
          </label>
          <label className="field">
            <span className="field-label">Contact desk / email</span>
            <input
              className="field-input"
              value={contact}
              onChange={(event) => setContact(event.target.value)}
              placeholder="Events desk or email"
            />
          </label>
          <label className="field">
            <span className="field-label">Event listing URL</span>
            <input
              className="field-input"
              type="url"
              value={url}
              onChange={(event) => setUrl(event.target.value)}
              placeholder="https://sdchamber.org/events/…"
            />
          </label>
          {error ? <p className="the-hub-error">{error}</p> : null}
          <button className="primary-btn" type="submit">
            Save listing
          </button>
        </form>
      ) : null}
    </ModalBase>
  );
}
